<template>
  <div
    v-if="accessory"
    class="accessory__wrap">
    <router-link :to="`accessories/${accessory.custom_fields.frontend_slug}`">
      <div
        v-if="accessory.custom_fields"
        class="accessory__image-wrap">
        <img
          :src="accessory.custom_fields.product_image.url"
          :alt="accessory.custom_fields.product_image.alt"
        >
      </div>
      <h3 class="accessory__title">{{ accessory.custom_fields.product_name }}</h3>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    accessory: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.accessory {
  @include e("wrap") {
    width: 30%;
    margin-bottom: 15px;

    @media screen and (max-width: 800px) {
      width: 50%;
    }

    @media screen and (max-width: 550px) {
      width: 100%;
    }
  }

  @include e(container) {
    max-width: 210px;
    margin: 0 auto;
  }

  @include e("image-wrap") {
    img {
      width: 100%;
      max-width: 100%;
    }
  }

  @include e("title") {
    margin: 5px 0px 0px;
    font-size: 28px;
    font-weight: normal;
    line-height: 1em;

    text-align: center;

    @media screen and (max-width: 850px) {
      font-size: 24px;
    }
  }
}
</style>
